import {getFlagEmojiHexFromCountryCode, getGlobeEmojiFexFromContinentCode} from './ClientUtils'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables.ts'

export function getCountryOrContinentImageLink(countryCode: string | undefined, continentCode?: string | undefined): string {
    const flagEmojiHexCode = (typeof countryCode === 'string') ? getFlagEmojiHexFromCountryCode(countryCode) : getGlobeEmojiFexFromContinentCode(continentCode)
    if(UIUtilsEjsVariables.isUserOnDiscord) return `/.proxy/jsdelivr/npm/twemoji@11.0.1/2/svg/${flagEmojiHexCode}.svg`
    return `https://cdn.jsdelivr.net/npm/twemoji@11.0.1/2/svg/${flagEmojiHexCode}.svg`
}
